/**
 * @flow
 * @relayHash 4efc95deb379d2180d45b19b25ce3f5a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ArticleSpellCheckStatusRefetchQueryVariables = {|
  id: string
|};
export type ArticleSpellCheckStatusRefetchQueryResponse = {|
  +spellCheckStatus: ?{|
    +id: ?string,
    +checkId: string,
    +userId: ?string,
    +startedAt: string,
    +response: ?string,
    +passed: boolean,
    +error: ?string,
    +user: ?{|
      +id: string,
      +name: ?string,
    |},
  |}
|};
export type ArticleSpellCheckStatusRefetchQuery = {|
  variables: ArticleSpellCheckStatusRefetchQueryVariables,
  response: ArticleSpellCheckStatusRefetchQueryResponse,
|};
*/


/*
query ArticleSpellCheckStatusRefetchQuery(
  $id: ID!
) {
  spellCheckStatus(id: $id) {
    id
    checkId
    userId
    startedAt
    response
    passed
    error
    user {
      id
      name
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "spellCheckStatus",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id",
        "type": "ID!"
      }
    ],
    "concreteType": "SpellCheckStatus",
    "plural": false,
    "selections": [
      v1,
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "checkId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "userId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "startedAt",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "response",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "passed",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "error",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          v1,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ArticleSpellCheckStatusRefetchQuery",
  "id": null,
  "text": "query ArticleSpellCheckStatusRefetchQuery(\n  $id: ID!\n) {\n  spellCheckStatus(id: $id) {\n    id\n    checkId\n    userId\n    startedAt\n    response\n    passed\n    error\n    user {\n      id\n      name\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ArticleSpellCheckStatusRefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v2
  },
  "operation": {
    "kind": "Operation",
    "name": "ArticleSpellCheckStatusRefetchQuery",
    "argumentDefinitions": v0,
    "selections": v2
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4b2d91dea17164a366640c99d19223b8';
module.exports = node;



// WEBPACK FOOTER //
// src/components/articles/__generated__/ArticleSpellCheckStatusRefetchQuery.graphql.js